import React from "react";
import { useLocation } from "react-router-dom";
import { BellIcon, MenuAlt2Icon, SparklesIcon } from "@heroicons/react/outline";

const pageTitles = {
  "/admin/dashboard": "Dashboard",
  "/admin/tour-places": "Home page headings",
  "/admin/view-places": "Places",
  "/admin/landing-page": "Landing page details",
  "/admin/add-explore-images": "Explore images",
  "/admin/tour-gallery": "Tour gallery",
  "/admin/route-maps": "Route maps",
  "/admin/view-tour-details": "Trip details",
  "/admin/complete-your-day": "Complete Your Day",
  "/admin/frequently-booked-together": "Frequently Booked Together",
  "/admin/explore-more-destinations": "Explore More Destinations",
};

export default function TopBar({ toggleSidebar, sidebarOpen = false }) {
  const { pathname } = useLocation();
  const adminLoginName = localStorage.getItem("adminName") || "Admin";
  const title = pageTitles[pathname] || "Admin workspace";
  const initial = adminLoginName.trim().charAt(0).toUpperCase() || "A";

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-30 flex h-20 items-center justify-between border-b border-slate-200/80 bg-white/85 px-4 backdrop-blur-xl transition-[left] duration-300 sm:px-6 lg:px-8 ${
        sidebarOpen ? "lg:left-64" : "lg:left-20"
      }`}
    >
      <div className="flex min-w-0 items-center gap-3 sm:gap-4">
        <button
          type="button"
          aria-label={sidebarOpen ? "Collapse navigation" : "Expand navigation"}
          aria-expanded={sidebarOpen}
          onClick={toggleSidebar}
          className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-sky-200 hover:text-sky-600 hover:shadow-md focus:outline-none focus:ring-4 focus:ring-sky-100"
        >
          <MenuAlt2Icon className="h-5 w-5" />
        </button>
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-xs font-medium text-slate-400">
            <SparklesIcon className="h-3.5 w-3.5 text-sky-500" />
            <span className="hidden sm:inline">GoSehari Admin</span>
            <span className="hidden sm:inline">/</span>
            <span className="truncate">Workspace</span>
          </div>
          <h1 className="mt-1 truncate text-base font-semibold tracking-tight text-slate-900 sm:text-xl">{title}</h1>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <button
          type="button"
          aria-label="Notifications"
          className="relative grid h-10 w-10 place-items-center rounded-xl text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus:ring-4 focus:ring-sky-100"
        >
          <BellIcon className="h-5 w-5" />
          <span className="absolute right-2.5 top-2.5 h-2 w-2 rounded-full border-2 border-white bg-rose-500 animate-pulse" />
        </button>
        <div className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white py-1.5 pl-1.5 pr-2 shadow-sm sm:pr-3">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-sky-500 to-indigo-600 text-xs font-bold text-white shadow-sm">{initial}</span>
          <span className="hidden max-w-28 truncate text-sm font-semibold text-slate-700 sm:inline">{adminLoginName}</span>
        </div>
      </div>
    </header>
  );
}
